import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import ReactDOM from 'react-dom';
import { isEmpty, isEqual, noop } from 'lodash';
import { VideoCard } from './card/card';
import { VIDEO_CARD_TYPES, VIDEO_CARDS_POSITIONS, CardData } from '@wix/wix-vod-constants/video-cards';
// @ts-expect-error
import { ANCHOR_POINTS } from '@wix/wix-vod-cards/dist/src/cards-module/constants';
const anchorPointsMap = {
  [VIDEO_CARDS_POSITIONS.BOTTOM_LEFT]: ANCHOR_POINTS.BOTTOM_LEFT,
  [VIDEO_CARDS_POSITIONS.BOTTOM_RIGHT]: ANCHOR_POINTS.BOTTOM_RIGHT
};
const getPlayerCardData = _ref => {
  let {
    cardData,
    index,
    contentNode
  } = _ref;
  const {
    clientId: id,
    from,
    to
  } = cardData;
  const order = index;
  const hasDynamicContent = cardData.type === VIDEO_CARD_TYPES.SOCIAL;
  return {
    id,
    from,
    to,
    order,
    contentNode,
    hasDynamicContent
  };
};
class VideoCardWrap extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "contentNode", document.createElement('div'));
    _defineProperty(this, "setCardAccessible", isAccessible => {
      this.setState({
        isAccessible
      });
    });
    const {
      player
    } = this.props;
    this.state = {
      isAccessible: false
    };
    player.onCardHidden(() => this.setCardAccessible(false));
    player.onCardShown(() => this.setCardAccessible(true));
  }
  getPlayerCardData(props) {
    const {
      cardData,
      index
    } = props;
    const {
      contentNode
    } = this;
    return getPlayerCardData({
      contentNode,
      cardData,
      index
    });
  }
  componentDidMount() {
    const {
      player
    } = this.props;
    player.addCard(this.getPlayerCardData(this.props)).then(() => this.updateActiveCard());
  }
  componentDidUpdate(oldProps) {
    const newCardData = this.getPlayerCardData(this.props);
    const oldCardData = this.getPlayerCardData(oldProps);
    if (!isEqual(oldCardData, newCardData)) {
      const {
        player
      } = this.props;
      player.updateCards([newCardData]).then(() => this.updateActiveCard());
    }
  }
  updateActiveCard() {
    const {
      player,
      isActive,
      cardData
    } = this.props;
    if (!isActive) {
      return;
    }
    player.setActiveCard(cardData.clientId);
  }
  componentWillUnmount() {
    const {
      player,
      cardData
    } = this.props;
    if (player && player.removeCard) {
      player.removeCard(cardData.clientId);
    }
  }
  render() {
    const {
      onCardClick,
      labels,
      cardData
    } = this.props;
    const {
      isAccessible
    } = this.state;
    return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(VideoCard, {
      labels: labels,
      isAccessible: isAccessible,
      cardData: cardData,
      onCardClick: onCardClick
    }), this.contentNode);
  }
}
const getCardsAnchorPoint = cardsData => {
  // all cards contain position value, and it's the same for all cards
  const [sampleCard] = cardsData;
  return anchorPointsMap[sampleCard.position];
};
class VideoCards extends React.PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "cardsConfig", {
      anchorPoint: ANCHOR_POINTS
    });
  }
  componentDidUpdate() {
    this.updateCardsConfig();
  }
  updateCardsConfig() {
    const {
      player,
      cardsData
    } = this.props;
    if (!player || isEmpty(player) || isEmpty(cardsData)) {
      return;
    }
    const newAnchorPoint = getCardsAnchorPoint(cardsData);
    if (newAnchorPoint !== this.cardsConfig.anchorPoint) {
      player.setAnchorPoint(newAnchorPoint);
      this.cardsConfig.anchorPoint = newAnchorPoint;
    }
    // TODO update cards orientation
  }

  render() {
    const {
      player,
      cardsData,
      onCardClick,
      labels,
      activeVideoCard
    } = this.props;
    if (!player || isEmpty(player)) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, cardsData.map((cardData, index) => /*#__PURE__*/React.createElement(VideoCardWrap, {
      key: cardData.clientId,
      player: player,
      labels: labels,
      onCardClick: onCardClick,
      cardData: cardData,
      index: index,
      isActive: !!activeVideoCard && cardData.clientId === activeVideoCard.clientId
    })));
  }
}
_defineProperty(VideoCards, "defaultProps", {
  onCardClick: noop
});
export { CardData, VideoCards, VIDEO_CARD_TYPES, VIDEO_CARDS_POSITIONS };
//# sourceMappingURL=video-cards.js.map